"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    menuItemLinkClassNames: function() {
        return menuItemLinkClassNames;
    },
    useMenuItemLinkStyles_unstable: function() {
        return useMenuItemLinkStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _useMenuItemStylesstyles = require("../MenuItem/useMenuItemStyles.styles");
const menuItemLinkClassNames = {
    root: 'fui-MenuItemLink',
    icon: 'fui-MenuItemLink__icon',
    checkmark: 'fui-MenuItemLink__checkmark',
    content: 'fui-MenuItemLink__content',
    secondaryContent: 'fui-MenuItemLink__secondaryContent'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    resetLink: {
        w71qe1: "f1iuv45f",
        Bkioxbp: "f9pkogg",
        I8pafv: "foe20s3",
        dvvfom: "f1kn6jj"
    }
}, {
    d: [
        ".f1iuv45f{text-decoration-line:none;}",
        ".f9pkogg{text-decoration-thickness:initial;}",
        ".foe20s3{text-decoration-style:initial;}",
        ".f1kn6jj{text-decoration-color:initial;}"
    ]
});
const useMenuItemLinkStyles_unstable = (state)=>{
    'use no memo';
    (0, _useMenuItemStylesstyles.useMenuItemStyles_unstable)(state);
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(menuItemLinkClassNames.root, styles.resetLink, state.root.className);
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(menuItemLinkClassNames.icon, state.icon.className);
    }
    if (state.content) {
        state.content.className = (0, _react.mergeClasses)(menuItemLinkClassNames.content, state.content.className);
    }
    if (state.secondaryContent) {
        state.secondaryContent.className = (0, _react.mergeClasses)(menuItemLinkClassNames.secondaryContent, state.secondaryContent.className);
    }
    if (state.checkmark) {
        state.checkmark.className = (0, _react.mergeClasses)(menuItemLinkClassNames.checkmark, state.checkmark.className);
    }
    return state;
};
